/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const UpdateNotificationPolicyHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type UpdateNotificationPolicyHeaders = zod.input<typeof UpdateNotificationPolicyHeaders>;
export type UpdateNotificationPolicyHeadersOutput = zod.output<
  typeof UpdateNotificationPolicyHeaders
>;
